const teachers = {
  teachers: "Lehrkräfte",
  welcomeTeacherPersonalHome: "Willkommen in Ihrem persönlichen Bereich",
  teacherNotSubscribedMessage:
    "Um diese Funktion nutzen zu können, müssen mindestens 10 Schülerinnen und Schüler abonniert sein.",
  teacher: "Lehrkraft",
  teacherDetail: "Lehrkraft-Details",
  teacherNotActivated: "Diese Lehrkraft hat ihr Konto noch nicht aktiviert.",
  teacherWithColon: "Lehrkraft:",
};

export default teachers;
